<template>
  <div id="app">
    <router-view />
    <SiteFooter />
  </div>
</template>

<script>

import SiteFooter from "./components/SiteFooter.vue";

export default {
  name: "App",
  components: {
    SiteFooter,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 40px;
}
</style>
